var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ce9bb2d99ed373f2ed7a14298d6e799b24802f5f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react@graphite"]={id:"ce9bb2d99ed373f2ed7a14298d6e799b24802f5f"};
      